/***
**Module Name: AddQuestion
 **File Name :  AddQuestion.js
 **Project :    Dadi
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  Kiran Kumar
 **author :  Mani Kanta
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: 2025-04-22
 **Last modified on: Dec 29 2022
 **Description : contains add user details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
// import Sidebar from "../../components/dashboard/sidebar";
import tmdbApi from "../../api/tmdbApi";
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from "moment";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import the Quill stylesimport axios from 'axios';
import { useNavigate, Link, useLocation, useParams } from "react-router-dom";
import { contentContext } from "../../context/contentContext";
import DataTable from 'react-data-table-component';
import TableLoader from "../../components/tableLoader";
import Loader from "../../components/loader";
import Select from 'react-select';
import axios from 'axios';
import parse from "react-html-parser";
import Editor from 'react-simple-wysiwyg';
import { v4 as uuid } from 'uuid';

let { appname, lambda, country } = window.app;


const AddQuestion = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { quizinfo } = state || {};
    const [selectedRows, setSelectedRows] = useState([]);
    const [success, setSuccess] = useState(false);
    const [uploadImg, setUploadImg] = useState(false);

    const [typeSelected, setType] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        answer: "",
        description: ""
    });
    const [errorData, setError] = useState({});
    const [errorDisplay, seterrorDisplay] = useState(false);
    // const [imageCloudfront, setImg] = useState(false);
    // const [resourceCloudfront, setResourceImage] = useState(false);
    // const [resourceBucket, setResourceImg] = useState(false);
    const [files, setFiles] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [qdisplay, setQdisplay] = useState(true);
    //const [answersdata, setAnswers] = useState([]);
    const [quizData, setQuizData] = useState(null);
    const [deleteQuestion, setdeleteQuestion] = useState(false);
    const [questionId, setQuestionId] = useState(null);
    const [deleteSuccess, setDeleteSuccess] = useState(false);
    const [questionData, setQuestionData] = useState(null);
    const [imagedisplay, setImageDisplay] = useState(false);
    const [updatesuccess, setUpdateSuccess] = useState(false);
    const [toggleClearRows, setToggleClearRows] = useState(false);
    const [imagesUrls, setImageUrls] = useState(null);
    const [imageFiles, setImageFiles] = useState([])
    const [imageIndex, setImageIndex] = useState(0)
    const [alertPopup, setAlertPopup] = useState(false)
    const [deleteImage, setdeleteImage] = useState(false);
    const [deleteImageId, setDeleteImageId] = useState(null);

    const [deleteImageSuccess, setDeleteImageSuccess] = useState(false);

    const [imageErrorFiles, setImageErrorFiles] = useState([])
    const [fileSizeError, setFileSizeError] = useState(false);
    const [fileSizeErrorMsg, setFileSizeErrorMsg] = useState("");

    const [creationQuestionLoader, setCreationQuestionLoader] = useState(false)

    // const [columns, setColumms] = useState([])
    const [inputChange, setInputChange] = useState(true);

    const { route, setRoute, currentPage, setcurrentPage, setCurrentPage, setRowsPerPage, isLoading, rowsPerPage, usePrevious, currentPageNew, setCurrentPageisLoading, setIsLoading, setActiveMenuObj, setActiveMenuId, GetTimeActivity, answersdata, setAnswers, resourceCloudfront, setResourceImage, resourceBucket, setResourceImg, imageCloudfront, setImg } = useContext(contentContext);

    const prevRoute = usePrevious(route)

    let columns = [
        {
            name: 'Sl No',
            selector: (row, index) => {
                return getSerialNumber(index);
            },
        },
        {
            name: 'Question',
            cell: (props) =>
                //  {subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
                <div className="question">

                    <div className="question_right">
                        <div className="qr">
                            <p className="left">Title: </p>
                            <p className="font-size-14">{props.name}</p>
                        </div>
                        <div className="qr">
                            <p className=" left">Question:  </p>
                            <p >{parse(props.description)}</p>
                        </div>
                        <div className="qr">
                            <p className=" left">Answer:  </p>
                            <p className="text-success">{props.answer}</p>
                        </div>
                    </div>
                    {props?.files && props?.files.length > 0 && <div className="question_left">
                        <span className="count">{props?.files.length}</span>
                        <img src={`${imageCloudfront}${props?.files[0]?.sourcepath.replace(/ /g, "%20")}?auto=compress,format&width=150`} /></div>}


                </div>
            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        {
            name: 'Created Title',
            selector: (row, index) => {
                return <div className="date">
                    {moment.utc(row?.created).format('DD MMM YYYY, HH:mm:ss')}
                </div>;
            },
        },
        {
            name: 'Actions',
            cell: (props) =>


                <div className="d-flex">

                    <a className='text-info action-button mr-5' onClick={(e) => handleEdit(e, 'Edit', props)}><i className="mdi mdi-pencil font-size-18"></i></a>

                    <a className='text-danger action-button' onClick={(e) => handleDelete(e, props)}><i className="mdi mdi-delete font-size-18"></i></a>

                </div>
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ]

    useEffect(() => {
        if (quizinfo) {
            setQuizData(quizinfo)
        }
    }, [quizinfo]);

    // useEffect(() => {

    //     if (window.site === undefined) {
    //         setTimeout(() => {
    //             if (window.site && window.site.common && window.site.common.imageCloudfront) {
    //                 setImg(window.site.common.imageCloudfront)
    //                 setResourceImg(window.site.common.resourceBucket)
    //                 setResourceImage(window.site.common.resourcesCloudfront)
    //             }
    //         }, 1000);
    //         siteInfo()
    //     }
    //     if (window.site && window.site.common && window.site.common.imageCloudfront) {
    //         setImg(window.site.common.imageCloudfront)
    //         setResourceImg(window.site.common.resourceBucket)
    //         setResourceImage(window.site.common.resourcesCloudfront)
    //     }


    // }, [window.site]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/admin");
        }
        // siteInfo()
        GetQuestionsInfo()
        setcurrentPage(1);
        setCreationQuestionLoader(false)
    }, []);

    useEffect(() => {
        if (creationQuestionLoader) {
            document.body.classList.add("loader-show");
        } else {
            document.querySelector('body').classList.remove('loader-show');
        }

    }, [creationQuestionLoader]);

    useEffect(() => {
        if (questionData) {
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                name: questionData?.name,
                answer: questionData?.answer,
                description: questionData?.description
            }));
            setImageIndex(questionData?.files?.length || 0)

        }
    }, [questionData]);

    const siteInfo = async () => {

        try {
            const response = await tmdbApi.configData();
            setImg(response?.result[0]?.common.imageCloudfront)
            setResourceImg(response?.result[0]?.common.resourceBucket)
            setResourceImage(response?.result[0]?.common.resourcesCloudfront)

            GetQuestionsInfo()
            // GetAnswersInfo()

        } catch {
            console.log("error");
            // setLoadContent(true)
        }
    };

    // useEffect(() => {
    //     // console.log('ffils', files, imageFiles)
    //     if (imageFiles && files && imageFiles.length > 0 && files.length > 0 && (imageFiles.length == files.length)) {
    //         // createQuestion(formData);
    //     }
    // }, [files, imageFiles]);

    // useEffect(() => {

    // //    console.log(questions?.status)
    //     let columnList = [
    //         {
    //             name: 'Sl No',
    //             selector: (row, index) => {
    //                 return getSerialNumber(index);
    //             },
    //         },
    //         {
    //             name: 'Question',
    //             cell: (props) =>
    //                 //  {subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
    //                 <div className="question">

    //                     <div className="question_right">
    //                         <div className="qr">
    //                             <p className="left">Title: </p>
    //                             <p className="font-size-14">{props.name}</p>
    //                         </div>
    //                         <div className="qr">
    //                             <p className=" left">Question:  </p>
    //                             <p >{parse(props.description)}</p>
    //                         </div>
    //                         <div className="qr">
    //                             <p className=" left">Answer:  </p>
    //                             <p className="text-success">{props.answer}</p>
    //                         </div>
    //                     </div>
    //                     {props?.files && props?.files.length > 0 && <div className="question_left">
    //                         <span className="count">{props?.files.length}</span>
    //                         <img src={`${imageCloudfront}${props?.files[0]?.filepath}?auto=compress,format&width=150`} /></div>}


    //                 </div>
    //             //  }
    //             ,
    //             ignoreRowClick: true,
    //             allowOverflow: true,
    //             button: true,
    //         },
    //         {
    //             name: 'Created Title',
    //             selector: (row, index) => {
    //                 return <div className="date">
    //                     {moment.utc(row?.created).format('DD MMM YYYY, HH:mm:ss')}
    //                 </div>;
    //             },
    //         },
    //         {
    //             name: 'Actions',
    //             cell: (props) =>


    //                 <div className="d-flex">
    //                     {questions?.status == "INACTIVE" ?
    //                     <><a className='text-info action-button mr-5' onClick={(e) => handleEdit(e, 'Edit', props)}><i className="mdi mdi-pencil font-size-18"></i></a>

    //                     <a className='text-danger action-button' onClick={(e) => handleDelete(e, props)}><i className="mdi mdi-delete font-size-18"></i></a>
    //                     </>: <></>}
    //                 </div>
    //             ,
    //             ignoreRowClick: true,
    //             allowOverflow: true,
    //             button: true,
    //         },
    //     ];
    //     setColumms(columnList)

    // }, [questions]);

    const handleBack = (e) => {
        if (qdisplay == true) {
            navigate("/dashboard");
        } else {
            setQdisplay(!qdisplay)
        }

    }

    const onDescriptionChange = (e) => {
        setFormData((prevData) => ({
            ...prevData,
            description: e.target.value // Update the 'description' field with Quill editor value
        }));
        setInputChange(false)
    };

    const GetAnswersInfo = async () => {

        try {
            const response = await tmdbApi.answerInfo();
            setAnswers(response?.result?.answerData);
        } catch {
            console.log("error");
        }
    };

    const GetQuestionsInfo = async () => {
        setIsLoading(true)
        try {
            let params = {
                quizid: id
            }
            const response = await tmdbApi.questionInfo(params);
            setQuestions(response?.result);
            setIsLoading(false)
        } catch {
            console.log("error");
        }
    };


    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            [name]: value, // Update the changed field
        }));
        setInputChange(false)
    };


    function onConfirm() {
        setSuccess(false);
        setQdisplay(true)
        GetQuestionsInfo()
        setInputChange(true)
        // window.location.reload()
    };



    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No content found</p>
                </div> </div>
        )
    }



    const handleQuestion = (e) => {
        e.preventDefault()
        setType('Add')
        setQdisplay(!qdisplay)
        setQuestionData(null)
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            name: "",
            answer: "",
            description: ""
        }));
        setImageFiles([])
        setImageUrls(null)
        setImageIndex(0)
    }

    const handleEdit = (e, type, props) => {
        e.preventDefault()
        setQdisplay(!qdisplay)
        setType(type)
        setQuestionData(props)
    }

    const handleSelectChange = (e) => {
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            ["answer"]: e.value, // Update the changed field
        }));
        setInputChange(false)
    }

    const handleAddQuestion = (e) => {
        const isValid = formvalidation();
        console.log(imageFiles, 'imageFiles')
        if (isValid) {
            if (imageFiles && imageFiles.length > 0) {
                handleFileUpload(e)
            } else {
                createQuestion(formData, []);
            }
        }
    }

    const createQuestion = async (formData, imageFiles) => {
        try {
            setCreationQuestionLoader(true)
            let response;
            // let getFiles = imageFiles && imageFiles?.length > 0 ? [...imageFiles] : [...files]
            // console.log('getFilesgetFiles add question',imageFiles)
            if (imageFiles && imageFiles.length > 0) {
                formData["files"] = imageFiles
            } else {
                if (formData["files"]) {
                    delete formData["files"]
                }
            }
            // console.log('form',formData)
            if (typeSelected == "Edit") {
                response = await tmdbApi.UpdateQuestion(formData, questionData?.questionid, id);
            } else {
                formData["quizid"] = id
                const questionid = uuid();
                formData["questionid"] = questionid
                response = await tmdbApi.AddQuestion(formData);
            }
            // console.log(response);
            if (response?.statusCode == 200) {
                setCreationQuestionLoader(false)
                setSuccess(true);
                setImageUrls(null)
                setImageFiles([])
            }
        } catch {
            console.log("error");
        }
    };


    function formvalidation() {
        let formIsValid = true;

        // console.log('form', formData)
        if (formData?.name == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["name"]: "Please enter Name", // Update the changed field
            }));
            seterrorDisplay(true)
            setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["name"]: "", // Update the changed field
            }));
        }



        // if (formData?.answer == "") {

        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["answer"]: "Please select answer", // Update the changed field
        //     }));
        //     seterrorDisplay(true)
        //     setTimeout(function () { seterrorDisplay(false) }, 3000);
        //     formIsValid = false;
        // } else {
        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["answer"]: "", // Update the changed field
        //     }));
        // }

        if (formData?.description == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["description"]: "Please enter description", // Update the changed field
            }));
            seterrorDisplay(true)
            setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["description"]: "", // Update the changed field
            }));
        }

        return formIsValid;
    }

    const handleRowSelected = (state) => {
        setSelectedRows(state.selectedRows);
    }

    const ondeleteConfirm = (e) => {
        setDeleteSuccess(false)
        GetQuestionsInfo()
        setQuestionId(null)
        setSelectedRows([])
        setToggleClearRows(!toggleClearRows);
    }

    const handleDelete = async (e, item) => {
        setdeleteQuestion(true)
        setQuestionId(item.questionid)
    }

    const handleDeleteQuestion = (e) => {
        setdeleteQuestion(true)
    }
    const handlePerRowsChange = (newPerPage) => {
        setRowsPerPage(newPerPage);
    };
    const onDelete = async (e) => {

        try {
            if (selectedRows && selectedRows.length > 0) {
                let qids = []
                selectedRows.forEach(item => {
                    qids.push(item?.questionid)
                });

                let questionIDS = {
                    questionids: qids
                }

                const response = await tmdbApi.deleteQuestionslist(id, questionIDS);
            } else {
                let questionIDS = {
                    questionids: [questionId]
                }
                const response = await tmdbApi.deleteQuestion(id, questionIDS);
            }

            setDeleteSuccess(true)
        } catch {
            console.log("error");
        }
        setDeleteSuccess(true)
        setdeleteQuestion(false)

    }

    const onCancel = (e) => {
        setdeleteQuestion(false)
        setSelectedRows([])
        setToggleClearRows(!toggleClearRows);
    }



    const onDelImageCancel = (e) => {
        setdeleteImage(false)
        setDeleteImageId(null)

    }

    const ondeleteImageConfirm = (e) => {
        setDeleteImageSuccess(false)
        let deleteImageIndex = deleteImageId["index"]
        if (deleteImageIndex > -1) { // only splice array when item is found
            questionData["files"].splice(deleteImageIndex, 1); // 2nd parameter means remove one item only
        }
        setDeleteImageId(null)
        let imgIndex = imageIndex
        setImageIndex(imgIndex - 1)
    }

    const handleImageErrorDelete = (e, key) => {
        setImageErrorFiles(imageErrorFiles.filter(item => item.name !== key?.name));

    }

    const handleImageFileDelete = async (e, item, key) => {
        setdeleteImage(true)
        let obj = item
        obj["index"] = key
        setDeleteImageId(item)
    }

    const imageFileDelete = async (e) => {
        setdeleteImage(false)
        try {
            let params = {
                "source_bucket": resourceBucket,
                "sourcepath": deleteImageId?.sourcepath,
                "fileid": deleteImageId?.fileid
            }
            await tmdbApi.deleteImage(questionData?.questionid, params);

            setDeleteImageSuccess(true)
        } catch {
            console.log("error");
        }
    }

    const handleImageDelete = (e, key) => {
        let imgUrls = { ...imagesUrls }
        let imgIndex = imageIndex
        // console.log('imgIndex ', imgIndex)
        // console.log('imgIndex ', imgUrls[key]?.name)

        // let targetIndex = imageFiles.findIndex((each) => {each.name == imgUrls[key]?.name});
        // imageFiles.splice(targetIndex-1, 1);
        setImageFiles(imageFiles.filter(item => item.name !== imgUrls[key]?.name));

        // setImageFiles((imageFiles) => {
        //     return [
        //         ...imageFiles.filter((item, i) => item.name != imgUrls[key]?.name)
        //     ]
        // })

        if (imgUrls[key]) {
            delete imgUrls[key]
        }
        setImageUrls(imgUrls)
        setImageIndex(imgIndex - 1)

    }

    const handleFileChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        // console.log('ques', questionData?.files.length, imageFiles?.length, selectedFiles?.length)
        setInputChange(false)
        let filesLength = 0
        if (questionData && questionData?.files?.length > 0) {
            filesLength = filesLength + questionData?.files.length
        }
        if (imageFiles && imageFiles?.length > 0) {
            filesLength = filesLength + imageFiles?.length
        }
        if (selectedFiles && selectedFiles?.length > 0) {
            filesLength = filesLength + selectedFiles?.length
        }

        //  console.log('filesLength ', filesLength)
        if (filesLength > 10) {
            setAlertPopup(true)
            return;
        }
        //for multiple files
        setImageDisplay(true)
        // setImageFiles(selectedFiles)
        // setImageFiles((prevData) => ([
        //     ...prevData, // Keep the other fields intact
        //     selectedFiles
        // ]));

        Array.from(selectedFiles).map(async (file, index) => {
            // console.log('file', file)
            // console.log('setImageIndex ', imageIndex, index)
            let fileSize = 1048612 * 20 // 5MB
            if (file?.size < fileSize) {
                if (imageIndex > 0) {
                    index = index + imageIndex
                }
                let urlobj = URL.createObjectURL(file)
                let img = new Image();
                img.onload = function () {
                    // alert(this.width + " " + this.height);
                    // if (this.width < 3841) {
                    // if (this.width < 2000) {


                    setImageFiles((prevData) => ([
                        ...prevData, // Keep the other fields intact
                        file
                    ]));

                    setImageUrls((prevData) => ({
                        ...prevData, // Keep the other fields intact
                        ["blob" + index]: {
                            url: urlobj,
                            name: file?.name
                        }, // Update the changed field
                    }));
                    setImageIndex(index + 1)
                    // } else {
                    //     setFileSizeError(true)
                    //     setFileSizeErrorMsg("Resolution has been greater than 3840px and 2160px")
                    //     // let obj = {
                    //     //     name: file?.name,
                    //     //     size: file?.size,
                    //     //     width: this.width,
                    //     //     height: this.height,
                    //     //     error: "Resolution has been greater then 3840px and 2160px",
                    //     //     url: urlobj
                    //     // }
                    //     // setImageErrorFiles((prevData) => ([
                    //     //     ...prevData, // Keep the other fields intact
                    //     //     obj
                    //     // ]));
                    // }
                };
                img.src = urlobj;
            } else {
                setFileSizeError(true)
                setFileSizeErrorMsg("File size greater than 20MB")
            }


        })

    };

    const handleFileUpload = async (event) => {
        setUploadImg(true);

        if (imageFiles && imageFiles.length > 0) {
            let filesArray = [];

            // Convert all file uploads into an array of promises
            const uploadPromises = Array.from(imageFiles).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('userId');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");
                const uniqueId = new ObjectID().toString();

                let uploadFilePath;
                let bucket;

                if (file.type.startsWith('image/')) {
                    let filenameReplace = file.name.replace(/ /g, "_");
                    uploadFilePath = `${appname}/${id}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    bucket = resourceBucket;

                    const data = {
                        source_bucket: bucket,
                        sourcepath: uploadFilePath
                    };

                    const newFile = {
                        filename: filenameReplace.split('.')[0],
                        sourcepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    };

                    filesArray.push(newFile);

                    setFiles((files) => [...files, newFile]);

                    try {
                        // Get Upload URL
                        const uploadUrlResponse = await axios.post(
                            `${lambda}/uploadFiles?appname=${appname}`,
                            data,
                            { headers: { 'Content-Type': 'application/json' } }
                        );

                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const uploadUrl = uploadUrlResponse.data.result;

                            // Upload file to S3
                            const uploadResponse = await axios.put(uploadUrl, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            });

                            if (uploadResponse.status === 200) {
                                return true; // Successfully uploaded
                            } else {
                                throw new Error('Failed to upload file to S3');
                            }
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    } catch (error) {
                        console.error('File upload error:', error);
                        return false;
                    }
                }
            });

            // Wait for all upload promises to finish
            const results = await Promise.all(uploadPromises);

            // Check if all uploads were successful
            if (results.every(status => status === true)) {
                setUploadImg(false);

                createQuestion(formData, filesArray);
            } else {
                console.error('Some files failed to upload.');
            }
        }
    };

    const handlePageChange = (page) => {
        // console.log('currentPageNew page', page)
        setcurrentPage(page);

    };
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'list': 'bullet' }],
            ['bold', 'italic', 'underline', 'strike', 'link'],
        ],
    };
    const getSerialNumber = (index) => {
        // Serial number calculation: it continues from the last serial number of the previous page

        // console.log("ss", currentPage, rowsPerPage)
        return (currentPage - 1) * rowsPerPage + index + 1;
    };



    // console.log('imagesUrls ', imagesUrls, imageFiles, imageIndex, formData)
    // console.log('imageErrorFiles ', imageErrorFiles)

    console.log('currentPageNew ', qdisplay, questions)

    return (
        <>

            <div id="layout-wrapper">
                <Header />
                <sideMenu />
                {creationQuestionLoader && <Loader />}
                {isLoading ? <Loader /> : <div className="quiz-page main-content user-management create-user add_question">

                    <div className="page-content ">
                        <div className="container-fluid">



                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">

                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">Quiz Details</h4>

                                        </div>
                                        <div>
                                            <a onClick={handleBack} className="btn btn-primary">back</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">


                                <div className="col-xl-12">
                                    <div className="card">
                                        <div className="card-body border-bottom hed">
                                            <div className="flex-grow-1">
                                                <h3 className="fw-semibold">{questions?.name}</h3>
                                                {questions?.quizType == "Competitive" && <ul className="list-unstyled hstack gap-2 mb-0">
                                                    {/* <li>
                                                    Start Date: <span className="text-muted">{questions?.startDate && moment(new Date(questions?.startDate)).format('DD MMM, YYYY')}</span>
                                                    </li> */}
                                                    <li>
                                                        End Date: <span className="text-muted">{questions?.endDate && moment(new Date(questions?.endDate)).format('DD MMM, YYYY')}</span>
                                                    </li>
                                                </ul>}
                                            </div>

                                        </div>
                                        <div className="card-body">
                                            <div className="create-user-block create_question">
                                                <div className="form-block">
                                                    <div className="row">

                                                        {qdisplay && questions?.name ?
                                                            <>
                                                                <div className="col-lg-12">
                                                                    <div className="d-flex align-items-center mb-2">

                                                                        <div className="flex-grow-1">
                                                                            <h4 className="mb-2 card-title">Questions List</h4>

                                                                        </div>
                                                                        <div>
                                                                            {selectedRows && selectedRows.length > 0 &&
                                                                                <a onClick={(e) => handleDeleteQuestion(e)} className="btn btn-danger">Delete</a>} &nbsp;

                                                                            {questions?.status == "INACTIVE" && <a onClick={(e) => handleQuestion(e)} className="btn btn-sm create-quiz-btn">Add Question</a>}
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <DataTable
                                                                    // title=""
                                                                    columns={columns}
                                                                    className={questions?.status == "INACTIVE" ? "question_table_check" : "question_table"}
                                                                    keyField='_id'
                                                                    data={questions?.questionData}
                                                                    direction="auto"
                                                                    highlightOnHover
                                                                    fixedHeaderScrollHeight="300px"
                                                                    pagination
                                                                    responsive
                                                                    persistTableHead

                                                                    striped
                                                                    selectableRowsHighlight
                                                                    selectableRows={questions?.status == "INACTIVE" ? true : false}
                                                                    onSelectedRowsChange={handleRowSelected}
                                                                    subHeaderAlign="right"
                                                                    defaultSortField="name"
                                                                    subHeaderWra
                                                                    paginationPerPage={rowsPerPage}
                                                                    paginationDefaultPage={currentPage}
                                                                    onChangePage={handlePageChange}
                                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                                    noDataComponent={customNoRecords()}
                                                                    paginationTotalRows={questions?.length}
                                                                    paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                                    clearSelectedRows={toggleClearRows}
                                                                    paginationComponentOptions={{
                                                                        rowsPerPageText: 'Per page:',
                                                                        rangeSeparatorText: 'of',
                                                                        noRowsPerPage: false,
                                                                        selectAllRowsItem: false,
                                                                        selectAllRowsItemText: 'All',
                                                                    }}

                                                                //  progressComponent={<TableLoader />}
                                                                />
                                                            </>
                                                            : qdisplay == false &&
                                                            <div className="">
                                                                <h4>{typeSelected == "Add" ? `Create` : `Edit`} Question</h4>
                                                                <div className="row col-lg-12 col-md-12">
                                                                    <div className="mb-3 col-lg-6 col-md-6 input-field">
                                                                        <label className="form-label form-label">Title</label>
                                                                        <input id="name" name="name" placeholder="Enter question" type="text" className="form-control" aria-invalid="false" onChange={handleChange} value={formData?.name} />

                                                                        {errorDisplay && <span className="errormsg" style={{
                                                                            fontWeight: 'bold',
                                                                            color: 'red',
                                                                        }}>{errorData?.name}</span>}

                                                                    </div>
                                                                     <div className="col-lg-6 col-md-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form-label form-label">Youtube Video URL (optional)</label>
                                                                        <input id="youtube" name="youtube" placeholder="Youtube video URL" type="text" className="form-control" aria-invalid="false" onChange={handleChange} value={formData?.youtube} />

                                                                        
</div>
                                                                    </div>
                                                                                 <div className="col-lg-6 col-md-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form-label form-label">Question</label>
                                                                        {/* <textarea id="description" name="description" placeholder="Enter description" type="text" className="form-control" aria-invalid="false" onChange={handleChange} value={formData?.description} /> */}

                                                                        {/* <EditorProvider>
                                                         <Editor value={descvalue} onChange={(e)=> onDescriptionChange(e)}>
                                                             <Toolbar>
                                                             <BtnBold />
                                                             <BtnItalic />
                                                             </Toolbar>
                                                         </Editor>
                                                     </EditorProvider> */}

                                                                        <Editor name="description" value={formData?.description} onChange={(e) => onDescriptionChange(e)} />
                                                                        {/* <ReactQuill
                                                                            value={formData?.description}
                                                                            onChange={(e) => onDescriptionChange(e)}
                                                                            modules={modules}
                                                                        /> */}
                                                                        {errorDisplay && <span className="errormsg" style={{
                                                                            fontWeight: 'bold',
                                                                            color: 'red',
                                                                        }}>{errorData?.description}</span>}

                                                                    </div>
                                                                
                                                                </div>
                                                                </div>

                                                   
                                                                {/* <div className="col-md-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form-label form-label">Answer</label>

                                                                        <Select
                                                                            isMulti={false}
                                                                            placeholder={"Select Answer"}
                                                                            onChange={(e) => handleSelectChange(e)}
                                                                            options={answersdata && answersdata.map((eachItem) => { return { value: eachItem.answer, label: eachItem.answer } })}
                                                                            isClearable
                                                                            value={answersdata && answersdata.map((eachItem) => { return eachItem.answer == formData?.answer && { value: eachItem.answer, label: eachItem.answer } })}
                                                                        />

                                                                        {errorDisplay && <span className="errormsg" style={{
                                                                            fontWeight: 'bold',
                                                                            color: 'red',
                                                                        }}>{errorData?.answer}</span>}
                                                                    </div>
                                                                </div> */}
                                                               

                                                                <div className="col-md-12">
                                                                    <div className="mb-3 input-field">
                                                                        {/* <label className="form-label form-label">upload image</label> */}
                                                                        {imagesUrls && Object.keys(imagesUrls).length > 0 && Object.keys(imagesUrls)?.map((item, key) => {

                                                                            return (

                                                                                <div className="upload_images" key={key}>
                                                                                    <div className="img">
                                                                                        <img src={imagesUrls[item].url} />
                                                                                        <p> {imagesUrls[item].name} </p>
                                                                                    </div>
                                                                                    <span onClick={(e) => handleImageDelete(e, item)} className="material-symbols-outlined icon"> delete </span>
                                                                                </div>
                                                                            )
                                                                        })}

                                                                        {questionData?.files && questionData?.files.length > 0 && questionData?.files?.map((item, key) => {

                                                                            return (

                                                                                <div className="upload_images" key={key}>
                                                                                    <div className="img">
                                                                                        <img src={`${imageCloudfront}${item?.sourcepath.replace(/ /g, "%20")}?auto=compress,format&width=150`} />
                                                                                        <p>{item?.filename}</p>
                                                                                    </div>
                                                                                    <span onClick={(e) => handleImageFileDelete(e, item, key)} className="material-symbols-outlined icon"> delete </span>
                                                                                </div>
                                                                            )
                                                                        })}

                                                                    </div>
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <div className="file_upload">
                                                                        <span className="material-symbols-outlined icon"> upload_file </span>
                                                                        <input
                                                                            type="file"
                                                                            id="file-upload"
                                                                            accept="image/jpeg, image/png, image/gif"
                                                                            className="file-input"
                                                                            multiple={false}
                                                                            onChange={handleFileChange}
                                                                            style={{ display: 'none' }}
                                                                            disabled={formData?.name != "" && formData?.description != ""? false : true}
                                                                        />

                                                                        <label
                                                                            htmlFor="file-upload"
                                                                            className="stroke-btn btn create-quiz-btn border-0 px-3 py-2 mb-2 mb-lg-0 mt-3"
                                                                        >
                                                                            Select file
                                                                        </label>
                                                                    </div>
                                                                    <div className="file_requirements ">
                                                                        <p>   Maximum files: 10 </p>
                                                                        {/* <p>   File size: 20MB</p> */}
                                                                        <p>  Supported formats: JPG, PNG,  GIF</p>




                                                                    </div>

                                                                </div>

                                                                <div>
                                                                    {imageErrorFiles && imageErrorFiles.length > 0 && imageErrorFiles?.map((item, key) => {

                                                                        return (
                                                                            <div className="upload_images" key={key}>
                                                                                <div className="img">
                                                                                    <img src={item?.url} />
                                                                                    <p>{item?.error} </p>
                                                                                </div>
                                                                                <span onClick={(e) => handleImageErrorDelete(e, item)} className="material-symbols-outlined icon"> delete </span>
                                                                            </div>

                                                                        )
                                                                    })}
                                                                </div>
                                                                {/* {formData?.name != "" && formData?.description != "" && formData?.answer != "" &&
                                                                    <div className="col-md-6">
                                                                        <div className="mb-3 input-field">
                                                                            <label className="form-label form-label">UPLOAD IMAGE (Jpg or Png)</label>
                                                                            <div className="upload-zone">

                                                                                <div className="upload-icon">
                                                                                    

                                                                                    {imagesUrls && Object.keys(imagesUrls).length > 0 && Object.keys(imagesUrls)?.map((item, key) => {

                                                                                        return (
                                                                                            <img src={imagesUrls[item].url} width="150" key={key} />
                                                                                        )
                                                                                    })}

                                                                                    {questionData?.files && questionData?.files.length > 0 && questionData?.files?.map((item, key) => {

                                                                                        return (
                                                                                            <img src={imageCloudfront + item?.filepath} width="150" key={key} />
                                                                                        )
                                                                                    })}

                                                                                </div>


                                                                                <input
                                                                                    type="file"
                                                                                    id="file-upload"
                                                                                    accept="image/jpeg, image/png"
                                                                                    className="file-input"
                                                                                    multiple
                                                                                    onChange={handleFileChange}
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                <label
                                                                                    htmlFor="file-upload"
                                                                                    className="stroke-btn btn btn-primary rounded-pill px-3 py-2 mb-2 mb-lg-0 mt-3"
                                                                                >
                                                                                    Choose files
                                                                                </label>

                                                                            </div>
                                                                        </div>
                                                                    </div>} */}


                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <button className="btn btn-primary btn1" type="submit" onClick={e => handleAddQuestion(e)} disabled={inputChange}>{typeSelected == "Add" ? `CREATE` : `UPDATE`}</button>

                                                                        <button className="btn btn2" type="button" onClick={e => handleQuestion(e)}>CANCEL</button>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        }

                                                    </div>
                                                </div>


                                                <SweetAlert show={success}
                                                    custom
                                                    confirmBtnText="ok"
                                                    confirmBtnBsStyle="primary"
                                                    title={typeSelected == "Add" ? "Question created successfully" : "Question updated successfully"}
                                                    onConfirm={e => onConfirm()}
                                                >
                                                </SweetAlert>
                                                <SweetAlert
                                                    show={uploadImg}
                                                    title={"File Uploading......"}
                                                    showConfirm={false} // Hides the OK button
                                                >

                                                </SweetAlert>

                                                <SweetAlert show={deleteSuccess}
                                                    custom
                                                    confirmBtnText="ok"
                                                    confirmBtnBsStyle="primary"
                                                    title={"Deleted Successfully"}
                                                    onConfirm={e => ondeleteConfirm()}
                                                >
                                                </SweetAlert>

                                                <SweetAlert show={deleteQuestion}
                                                    warning
                                                    showCancel
                                                    confirmBtnText="Yes"
                                                    cancelBtnText="Cancel"
                                                    confirmBtnBsStyle="danger"
                                                    cancelBtnBsStyle="default"
                                                    title="Are you sure you want to delete?"
                                                    focusCancelBtn
                                                    onConfirm={e => onDelete()}
                                                    onCancel={e => onCancel()}
                                                >
                                                </SweetAlert>



                                                <SweetAlert show={deleteImage}
                                                    warning
                                                    showCancel
                                                    confirmBtnText="Yes"
                                                    cancelBtnText="Cancel"
                                                    confirmBtnBsStyle="danger"
                                                    cancelBtnBsStyle="default"
                                                    title="Are you sure you want to delete?"
                                                    focusCancelBtn
                                                    onConfirm={e => imageFileDelete(e)}
                                                    onCancel={e => onDelImageCancel(e)}
                                                >
                                                </SweetAlert>

                                                <SweetAlert show={deleteImageSuccess}
                                                    custom
                                                    confirmBtnText="ok"
                                                    confirmBtnBsStyle="primary"
                                                    title={"Deleted Successfully"}
                                                    onConfirm={e => ondeleteImageConfirm()}
                                                >
                                                </SweetAlert>

                                                <SweetAlert show={alertPopup}
                                                    warning
                                                    confirmBtnText="Ok"
                                                    confirmBtnBsStyle="danger"
                                                    cancelBtnBsStyle="default"
                                                    title="Maximum 10 files allowed"
                                                    focusCancelBtn
                                                    onConfirm={e => setAlertPopup(false)}
                                                >
                                                </SweetAlert>

                                                <SweetAlert show={fileSizeError}
                                                    warning
                                                    confirmBtnText="ok"
                                                    confirmBtnBsStyle="danger"
                                                    title={fileSizeErrorMsg}
                                                    onConfirm={e => setFileSizeError(false)}
                                                >
                                                </SweetAlert>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>



                    <Footer />
                </div>
                }


            </div>

        </>
    );
};

export default AddQuestion;
